import { serializeURLSearchParamsStably } from './serializeURLSearchParamsStably';

/**
 * Assembles a listings URL from its parts. The filterPath (e.g. "/-/p/-10/c/blue") is
 * injected between the basePath and the query string. Pass an empty string for filterPath
 * when no filters are active.
 */
export const buildListingsURL = (
  basePath: string,
  filterPath: string,
  queryParams: URLSearchParams,
  hash?: string,
): string => {
  const query = serializeURLSearchParamsStably(queryParams);
  const normalizedHash = hash ?? '';
  const normalizedBasePath = (basePath ?? '').replace(/\/-\/.*$/, '');
  const pathWithFilters = `${normalizedBasePath}${filterPath}`;
  return query
    ? `${pathWithFilters}?${query}${normalizedHash}`
    : `${pathWithFilters}${normalizedHash}`;
};
